import React, { useContext } from "react";
import parsePhoneNumber from 'libphonenumber-js/max';
import { AppContext } from "../../../../util/context";

import styles from "./PhoneInput.module.scss";
import block from 'bem-css-modules';

import { sanitizeContent as s } from "../../../../util/functions";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { IFieldProperties } from "../InputFields.types";

const PhoneInput = (props: { fieldData: IFieldProperties, register: UseFormRegister<any>, errors: FieldErrors }) => {
  const { settings: { locale } } = useContext(AppContext);
  const { 
    fieldData: {
      label,
      title,
      text,
      placeholder, 
      validationText,
      settings: [{
        crmProperty,
        required,
        validation
      }]
    },
    register,
    errors
  } = props;

  const b = block(styles);

  const handlePhoneValidation = (value: string) => {

    const countryCode:any = locale.split("-")[1];
    const phoneNumber = parsePhoneNumber(value, countryCode);
    const result = phoneNumber ? phoneNumber.isValid() : !!phoneNumber;
    return validation ? result : true;
  }

  return (
    <div className={b()}>
      {title && (
        <h3 className={b("title")} dangerouslySetInnerHTML={{ __html: s(title) }}/>
      )}
      {text && <div className={b("text")} dangerouslySetInnerHTML={{ __html: s(text) }} />}
      <input
        id={label}
        data-crm-field={crmProperty}
        placeholder={placeholder}
        type="tel"
        {...register(
          label,
          {
            validate: handlePhoneValidation,
            required: required
          }
        )}
      />
      {errors[label] && (
        <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
      )}
    </div>
  )
}

export default PhoneInput;